document.addEventListener('DOMContentLoaded', () => {
  ['category-filter-dropdown', 'year-filter-dropdown', 'filter-audience'].forEach(id => {
    const select = document.getElementById(id) as HTMLSelectElement | null;
    if (!select) return;
    select.addEventListener('change', event => {
      const url = (event.currentTarget as HTMLSelectElement).value;
      if (url) {
        window.location.href = url;
      }
    });
  });
});
